import { render, staticRenderFns } from "./Autopopulation.vue?vue&type=template&id=0fb36430&"
import script from "./Autopopulation.vue?vue&type=script&lang=js&"
export * from "./Autopopulation.vue?vue&type=script&lang=js&"
import style0 from "./Autopopulation.vue?vue&type=style&index=0&id=0fb36430&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports